import script from "./ModalConfirmaAgape.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalConfirmaAgape.vue?vue&type=script&setup=true&lang=js"

import "./ModalConfirmaAgape.vue?vue&type=style&index=0&id=50e823da&scoped=true&lang=css"

import exportComponent from "D:\\FOP\\AGAPE\\AGAPE_HOSPITALAR\\ReguaHospitalar\\frontpainel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50e823da"]])

export default __exports__